/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getAttributionOverviewV1QuerySchema = z.object({
  period: z.enum(['7d', '30d', 'all']).default('7d'),
});

export type IGetAttributionOverviewV1Query = z.input<typeof getAttributionOverviewV1QuerySchema>;
